module.exports = __webpack_public_path__ + "img/1.443b39a2.png";